module.exports = __webpack_public_path__ + "a6137456ed160d7606981aa57c559898.png";